import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PersonModel from './person.ts';
import type ObservableDocumentModel from './observable-document.ts';

export type ObservationType = 'boolean' | 'numeric' | 'int' | 'date' | 'text';

export default class ObservationModel extends Model {
  /*************************
   **  Attributes         **
   *************************/
  @attr declare name: string;
  @attr declare value: unknown;
  @attr declare observationType: ObservationType;
  @attr declare provider: string;
  @attr declare providedAt: string;
  @attr declare staleAfter: string | null;
  @attr declare weight: number;
  @attr declare createdAt: string;

  /*************************
   **  Relationships      **
   *************************/
  // Polymorphic: the Account or Loan this observation is about (type resolved from the payload).
  @belongsTo('', { async: false, inverse: null, polymorphic: true })
  declare observable: Model;

  @belongsTo('person', { async: false, inverse: null })
  declare person: PersonModel;

  @hasMany('observable-document', { async: false, inverse: 'observations' })
  declare observableDocuments: ObservableDocumentModel[];

  /*************************
   **  Computed           **
   *************************/
  // Dasherized model name of the polymorphic target, e.g. 'account' | 'loan'.
  get observableType(): string | undefined {
    const ctor = this.observable?.constructor as { modelName?: string } | undefined;
    return ctor?.modelName;
  }

  get isStale(): boolean {
    return Boolean(this.staleAfter) && new Date(this.staleAfter as string) <= new Date();
  }

  [Type] = 'observation' as const;
}
